import { render, staticRenderFns } from "./author-card.vue?vue&type=template&id=8ea5747a&scoped=true"
import script from "./author-card.vue?vue&type=script&lang=ts"
export * from "./author-card.vue?vue&type=script&lang=ts"
import style0 from "./author-card.vue?vue&type=style&index=0&id=8ea5747a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ea5747a",
  null
  
)

export default component.exports